"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputConnector = void 0;
const snap_ui_1 = require("@teamsnap/snap-ui");
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
const React = __importStar(require("react"));
const InputConnector = ({ input = {}, label, type, placeholder, options, required, maxLength, className, meta, repeater = false, maxRepeats = 5, autocomplete, disabled, }) => {
    const { name, value, onChange } = input;
    const { error } = meta;
    if (type === 'birthdate') {
        return React.createElement(snap_ui_1.Birthdate, { name, value, label, onChange, required, className, validate: true, errors: error });
    }
    if (type === 'radio-tab') {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `sui-flex sui-justify-between sui-items-center ${className ?? ''}` },
                React.createElement(snap_ui_1.Label, { className: "sui-mr-2", htmlFor: name }, label),
                React.createElement("div", null, options?.map(({ value: optionValue, label: optionLabel }) => (React.createElement(snap_ui_1.RadioTab, { key: optionValue, label: optionLabel, value: optionValue, name: name, inputProps: {
                        onChange: () => {
                            onChange(optionValue === '1' ? true : false);
                        },
                        checked: (optionValue === '1' && !!value) || (optionValue === '0' && !value),
                    } }))))),
            error && React.createElement("div", { className: "sui-text-negative-text sui-caption" }, error.join(' '))));
    }
    if (repeater) {
        const inputs = Array.isArray(value) ? value : [{ value: '', isPrimary: true }];
        return (React.createElement("div", { className: className },
            inputs.map((item, i) => (React.createElement("div", { className: `sui-flex sui-justify-between sui-items-center sui-mb-2`, key: i },
                React.createElement(snap_ui_1.Input, { inputProps: { maxLength, required }, errors: error ? error[i] : [], required: i === 0 ? required : false, name,
                    label,
                    value: item.value,
                    className,
                    options,
                    placeholder, onChange: (e) => {
                        const newInputs = [...inputs];
                        newInputs[i] = {
                            ...(newInputs[i] ? newInputs[i] : {}),
                            value: e.target.value,
                        };
                        onChange(newInputs);
                    }, type: type, className: "sui-flex-grow sui-mr-1" }),
                inputs.length > 1 && (React.createElement(snap_ui_1.LabelButton, { labelText: "Remove", icon: "delete", variantType: "tertiary", sentiment: "negative", onClick: () => {
                        const newInputs = [...inputs];
                        newInputs.splice(i, 1);
                        if (i === 0) {
                            // if we removed the primary input, make the next primary
                            newInputs[0] = { ...newInputs[0], isPrimary: true };
                        }
                        onChange(newInputs);
                    } }))))),
            inputs.length < maxRepeats && (React.createElement("div", { className: "sui-flex sui-justify-end" },
                React.createElement(snap_ui_1.LabelButton, { variantType: "tertiary", onClick: () => {
                        const newInputs = [...inputs, { value: '' }];
                        onChange(newInputs);
                    }, labelText: "Add another", icon: "add" })))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(snap_ui_1.Input, { inputProps: { maxLength, required, disabled }, errors: error, name,
            label,
            value,
            onChange,
            className,
            required,
            options,
            placeholder,
            autocomplete, type: type })));
};
exports.InputConnector = InputConnector;
exports.default = exports.InputConnector;
